export default function capitalizeFirstLetter(str) {
  if (str === undefined) {
    throw new NotStringException('Expected String, Received undefined.')
  }
  if (str === null) {
    throw new NotStringException('Expected String, Received Null.')
  }
  if (!(typeof str === 'string')) {
    throw new NotStringException('Expected String.')
  }
  return str.charAt(0).toUpperCase() + str.slice(1)
}

function NotStringException(message) {
  this.message = message
  this.name = 'Not String Exception'
}
